import { FlatLayoutComponent } from './flat.component'

export const LAYOUTS = [FlatLayoutComponent]
